import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  financialValuesAllIds,
  financialValuesById,
  allfinancialValuesItemsSelector,
] = resourceSelectors('financialValues');
